export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14911.d65e7c9b.jpg";